import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTables: [],
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setSelectedTables(state, action) {
      state.selectedTables = action.payload;
    },
    clearSelectedTables(state) {
      state.selectedTables = [];
    },
  },
});

export const { setSelectedTables, clearSelectedTables } = tableSlice.actions;
export default tableSlice.reducer;